import React, {Fragment} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import * as api from "../../apis/country";
import useAntTable from "../../utils/useAntTable";
import {Button, Divider, Popconfirm, Space} from "antd";
import WithAuth from "../../utils/withAuth";
import useFormModal from "../../utils/useFormModal";
import {useRequest} from "ahooks";
import ModifyModal from "./modifyModal";

const AddButton = WithAuth('add', Button)
const EditFragment = WithAuth('edit', Fragment)
const DeletePopconfirm = WithAuth('delete', Popconfirm)


function Country() {

    const {tableProps, refresh} = useAntTable(api.getCountries, {})

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.modifyCountry,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const {run: onDelete} = useRequest(api.deleteCountry, {
        manual: true,
        onSuccess: () => refresh()
    })

    const columns: StandardColumnsType = [
        {
            title: 'Country',
            dataIndex: 'country',
        },
        {
            title: 'CPQ cost upcharge(%)',
            dataIndex: 'costUpcharge',
        },
        {
            title: 'Tariff Surcharge',
            dataIndex: 'tariffSurcharge',
        },
        {
            title: 'Tariff Rate(%)',
            dataIndex: 'tariffRate',
        },
        {
            title: 'Freight Rate(%)',
            dataIndex: 'freightRate',
        },
        {
            title: 'Operations',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>
                    <EditFragment>
                        <a onClick={() => setVisible(true, record)}>Edit</a>
                        <Divider type={'vertical'}/>
                    </EditFragment>
                    <DeletePopconfirm title={'Are you sure?'} onConfirm={() => onDelete(record.id)}>
                        <a>Delete</a>
                    </DeletePopconfirm>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <AddButton type={'primary'} onClick={() => setVisible(true)}>Add</AddButton>
                </Space>
            )}/>
            <ModifyModal {...modalProps} />
        </PageHeaderLayout>
    )
}

export default Country
